/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1Person200,
  GetApiV1Person401,
  GetApiV1Person500,
  GetApiV1PersonQueryParams,
  GetApiV1PersonQueryResponse,
} from "../../types/personRegisterController/GetApiV1Person.ts";
import { personGridRepositoryResponsePaginatedResponseSchema } from "../personGridRepositoryResponsePaginatedResponseSchema.ts";

export const getApiV1PersonQueryParamsSchema = z.object({
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
  people: z.optional(z.string()),
  cpf: z.optional(z.string()),
  email: z.optional(z.string()),
  companyId: z.optional(z.coerce.number().int()),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<GetApiV1PersonQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1Person200Schema = z.lazy(
  () => personGridRepositoryResponsePaginatedResponseSchema,
) as unknown as ToZod<GetApiV1Person200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1Person401Schema =
  z.any() as unknown as ToZod<GetApiV1Person401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1Person500Schema =
  z.any() as unknown as ToZod<GetApiV1Person500>;

export const getApiV1PersonQueryResponseSchema = z.lazy(
  () => getApiV1Person200Schema,
) as unknown as ToZod<GetApiV1PersonQueryResponse>;
